var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPushkin = function SvgPushkin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.621 37.4c1.094-2.363 1.876-5.514-2.812-5.199m0 0c-3.5.378-3.126-1.417-2.5-2.363.312-.472.575-1.569.575-2.514m1.925 4.877c3.5-.378 8.484-4.231 12.39-3.601M9.885 27.324c-.325-1.087-.808-1.384-1.513-2.527-1.042-.052-2.72-.472-1.094-1.733C9.308 21.49 12.1 18.7 13.2 15.4M9.884 27.325c.84-.104 2.601-.337 2.919-.443m9.788 8.155c.486-.642 2.518-2.532 6.925-2.404 4.407.129 4.645-2.087 4.213-3.211 6.97 0 4.77-10.722.867-11.522 1.944-9.154-3.46-8.873-4.594-8.873C28.6 3.3 19.8 3.3 17.85 6.94c-7.95 0-2.45 7.36 3.05 7.36 5.995.752 5.5 3.3 5.5 5.5 0 0-.535 2.698-4.813 2.056C18.7 22 17.6 23.1 16.5 24.2",
    stroke: "#F44336",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.146 17.075 2.582.963-.796.796",
    stroke: "#F44336",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPushkin;